import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Showcase from './components/Showcase';
import Highlights from './components/Highlights';
import Gallery from './components/Gallery';
import CreatorSpotlight from './components/CreatorSpotlight';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import { useSiteConfig } from './utils/siteConfig';

function App() {
  useSiteConfig();

  return (
    <div className="min-h-screen" style={{ background: '#080C0B' }}>
      <Header />
      <Hero />
      <Showcase />
      <Gallery />
      <Highlights />
      <CreatorSpotlight />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;
